import {isRestError} from '../services/rest-client/RestError';

export const isRestErrorWithStatus = (
  error: unknown,
  statuses: readonly number[],
): boolean => isRestError(error) && statuses.includes(error.status);
